import * as React from "react";
import { style } from "typestyle";
import { GrayDark } from "@traceair/tds";

type Props = {
  logoUrl: string;
  title: string;
  subtitle: string;
  onClick: () => void;
  statusIcon?: string;
  statusText?: string | null;
};

export default function DashboardButton(props: Props): JSX.Element {
  const { logoUrl, title, subtitle, onClick, statusIcon, statusText } = props;
  return (
    <div
      className={style({
        display: "flex",
        flexDirection: "row",
        background: "white",
        cursor: "pointer",
        boxShadow: "0 0 2px 0 rgba(0,0,0,0.12), 0 2px 2px 0 rgba(0,0,0,0.24)",
        borderRadius: "12px",
        overflow: "hidden",
        opacity: 1,
        position: "relative",
        $nest: {
          "&:hover": {
            background: "#F5F5FA",
          },
        },
      })}
    >
      {!!logoUrl && (
        <img
          src={logoUrl}
          className={style({
            width: "128px",
            minWidth: "128px",
            height: "128px",
          })}
          onClick={onClick}
        />
      )}

      <div
        className={style({
          cursor: "pointer",
          padding: "0 16px",
        })}
        onClick={onClick}
        role="button"
      >
        <div
          className={style({
            flex: "1",
            fontWeight: "normal",
            lineHeight: "32px",
            color: "rgba(0,0,0,0.87)",
            fontSize: "24px",
            height: "32px",
            // marginLeft: '16px',
            marginTop: "26px",
          })}
        >
          {title}
        </div>
        {!!subtitle && (
          <div
            className={style({
              fontSize: "16px",
              lineHeight: "24px",
              color: "rgba(0,0,0,0.87)",
              // paddingLeft: '16px',
              marginTop: "8px",
            })}
          >
            {subtitle}
          </div>
        )}
      </div>
      {!!statusText && (
        <div
          className={style({
            margin: "24px 24px 0px 0px",
            color: GrayDark,
            fontSize: "14px",
            position: "absolute",
            right: "0",
          })}
        >
          {statusText}
          <img
            src={statusIcon}
            className={style({
              width: "18px",
              height: "18px",
              verticalAlign: "middle",
              marginLeft: "19px",
            })}
          />
        </div>
      )}
    </div>
  );
}
